<template>
<div class="chapter">
<div class="inner_page">
<p class="partno"><a id="page_9">P<span class="small">ART</span> I</a></p><a id="page_9">
<p class="parttitle">1914-1916</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_Part01.vue?5becd4a0